export default __webpack_public_path__ + "static/media/oakwood.79798d2a.PNG";